export const DEFAULT_OAI_ADS_PIXEL_ID = "5PnmnK3mey8SSN6pZybF1c";

export function resolveOaiAdsPixelId(value: string | undefined): string {
  return value ?? DEFAULT_OAI_ADS_PIXEL_ID;
}
